export default "__VITE_ASSET__BOI4h12g__"